import { env } from '~/env.mjs';

export const isStablyEmail = (value: string) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) && value.endsWith(`@${env.NEXT_PUBLIC_STABLY_EMAIL_DOMAIN}`);
};
